/**
* @license Apache-2.0
*
* Copyright (c) 2025 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //

import Complex128 from './../../../../float64/ctor';
import real from './../../../../float64/real';
import imag from './../../../../float64/imag';


// MAIN //

/**
* Computes the sum of three double-precision complex floating-point numbers.
*
* @param {Complex128} z1 - first complex number
* @param {Complex128} z2 - second complex number
* @param {Complex128} z3 - third complex number
* @returns {Complex128} result
*
* @example
* import Complex128 from '@stdlib/complex/float64/ctor';
*
* var z = new Complex128( 5.0, 3.0 );
*
* var out = add3( z, z, z );
* // returns <Complex128>[ 15.0, 9.0 ]
*/
function add3( z1, z2, z3 ) {
	var re = real( z1 ) + real( z2 ) + real( z3 );
	var im = imag( z1 ) + imag( z2 ) + imag( z3 );
	return new Complex128( re, im );
}


// EXPORTS //

export default add3;
